// extracted by mini-css-extract-plugin
export default {"tasks":"xN-z","task":"yN-z","svg":"zN-z","text":"AN-z"};